import { deobfuscateData, obfuscateData } from "./crypto";

export const setObfuscatedLocalStorage = <T>(key: string, data: T): void => {
  localStorage.setItem(key, obfuscateData(data));
};

export const getObfuscatedLocalStorage = <T>(key: string): T | null => {
  if (typeof window === "undefined") return null;
  const stored = localStorage.getItem(key);
  if (!stored) return null;

  try {
    return deobfuscateData<T>(stored);
  } catch {
    // Anything we cannot read is treated as absent: leftover crypto-js AES
    // blobs from before the migration, and entries corrupted by hand. Without
    // this the throw would propagate into store initialisation and break the
    // page instead of just starting from an empty state.
    return null;
  }
};
